import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2431541508/src/src/app/ui/common/side-menu.tsx");
